declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    env: any;
  }
}

// eslint-disable-next-line import/prefer-default-export
export const {
  // For integration with spindl-admin-fe
  REACT_APP_BASE_URL: BASE_URL = window.env?.REACT_APP_BASE_URL,
  REACT_APP_DATA_PATH: DATA_PATH = window.env?.REACT_APP_DATA_PATH,
  REACT_APP_SERVICE_URL_TEMPLATE: SERVICE_URL_TEMPLATE = window.env?.REACT_APP_SERVICE_URL_TEMPLATE,

  // For local development
  REACT_APP_DATA_API_URL: DATA_URL = window.env?.REACT_APP_DATA_API_URL,
} = process.env;

export const IS_DEV = process.env.NODE_ENV === 'development';
